import 'bootstrap'
import '@hotwired/turbo'
import '../controllers'
import '../src/common'

Turbo.start()

// Turboを無効化して必要なelementにdata-turbo="true"を追加する
Turbo.session.drive = false
